import styled from "styled-components";

export const Container = styled.div`
    align-items: center;
`;
export const Content = styled.div`
    width: 100%;
    height: 40rem;
    margin-top: 5vh;

    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000029;
    border-radius: 6px;
    opacity: 1;

    .addIcon{
            padding-right: 5px;
        }

`;